// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__33_HL","content":"RecentSearches_content__27Rc8"};